import { createPerimeter } from 'vue-kindergarten';
import { isRole } from '../utilities/roleUtilities';

export const OrdersPerimeter = createPerimeter({
    purpose: 'orders',

    can: {
        read () {
            return isRole.admin(this.child)
                || isRole.key_account(this.child)
                || isRole.shop_owner(this.child)
                || isRole.operator(this.child);
        },

        readDetails () {
            return isRole.admin(this.child)
                || isRole.key_account(this.child)
                || isRole.shop_owner(this.child);
        },

        viewAllOrders () {
            return isRole.admin(this.child)
                || isRole.key_account(this.child)
                || isRole.shop_owner(this.child);
        },

        // only admin can edit orders
        update () {
            return isRole.admin(this.child)
                || isRole.key_account(this.child)
                || isRole.shop_owner(this.child)
                || isRole.operator(this.child);
        },

        // if user can update articles then she can also destroy them
        destroy (order) {
            return this.isAllowed('update', order)
                || isRole.key_account(this.child)
                || isRole.shop_owner(this.child);
        }
    }
});
